import { RouterManager } from '@aclass/admin/managers';
import { UserStory } from '@aclass/admin/storage/actions';
import { IAdminState, IUserModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class UserEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:user-edit';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IUserModuleState['editPageRecordId']>(['userModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(UserEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.subscriptions.push(
            this.ngRdx.select<boolean>(['aclModule', 'initialized']).pipe(filter(v => v)).subscribe(() => {
                this.ngRdx.dispatch(UserStory.dryRunEditPage(this.id));
            })
        );
    }
}
